import React from 'react';
import ProgressBar from './ProgressBar';

// Back button — progress bar — Next/Submit button, in one row.
// hideBack/hideNext let an auto-advancing brand drop the manual controls
// while still showing progress.
function NavigationBar({ currentStep, totalSteps, onBack, onNext, backDisabled, nextLabel, hideBack = false, hideNext = false }) {
  return (
    <div className="survey-nav">
      {!hideBack && (
        <button
          type="button"
          className="survey-nav-back"
          onClick={onBack}
          disabled={backDisabled}
        >
          Back
        </button>
      )}
      <ProgressBar currentStep={currentStep} totalSteps={totalSteps} />
      {!hideNext && (
        <button
          type="button"
          className="survey-nav-next"
          onClick={onNext}
        >
          {nextLabel}
        </button>
      )}
    </div>
  );
}

export default NavigationBar;
